import { render, staticRenderFns } from "./WithdrawalStart.vue?vue&type=template&id=70cb7bd4&scoped=true&"
import script from "./WithdrawalStart.vue?vue&type=script&lang=js&"
export * from "./WithdrawalStart.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalStart.vue?vue&type=style&index=0&id=70cb7bd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cb7bd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
